import React, { useState } from 'react';

// Boosty баннеры
import boosty79 from '../../../images/mobile/boosty_79.png';
import boosty249 from '../../../images/mobile/boosty_249.png';
import boosty499 from '../../../images/mobile/boosty_499.png';
import boosty1499 from '../../../images/mobile/boosty_1499.png';

const DonateScreen = () => {
    const [selectedSum, setSelectedSum] = useState(100);
    const [customSum, setCustomSum] = useState('');
    const [isCustom, setIsCustom] = useState(false);
    const [comment, setComment] = useState('');

    const predefinedSums = [100, 200, 500, 1000];

    const handleSumClick = (sum) => {
        setSelectedSum(sum);
        setIsCustom(false);
        setCustomSum('');
    };

    const handleCustomClick = () => {
        setIsCustom(true);
        setSelectedSum(null);
    };

    const handleCustomChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setCustomSum(value);
    };

    const handleSubmit = () => {
        const finalSum = isCustom ? parseInt(customSum, 10) : selectedSum;

        if (!finalSum || finalSum < 1) {
            alert('Пожалуйста, выберите или введите сумму');
            return;
        }

        // Формируем URL для ЮMoney
        // message - сообщение для получателя (comment - только для отправителя)
        const yoomoneyUrl = `https://yoomoney.ru/quickpay/confirm?receiver=410015757768507&quickpay-form=button&sum=${finalSum}&message=${encodeURIComponent(comment)}`;

        window.open(yoomoneyUrl, '_blank');
    };

    const boostyBanners = [
        { img: boosty79, url: 'https://boosty.to/myata/purchase/2518433?ssource=DIRECT&share=subscription_link' },
        { img: boosty249, url: 'https://boosty.to/myata/purchase/2518434?ssource=DIRECT&share=subscription_link' },
        { img: boosty499, url: 'https://boosty.to/myata/purchase/2518435?ssource=DIRECT&share=subscription_link' },
        { img: boosty1499, url: 'https://boosty.to/myata/purchase/2518436?ssource=DIRECT&share=subscription_link' },
    ];

    return (
        <div className="mobile-screen donate-screen">
            <h1 className="donate-title">Помочь проекту</h1>

            {/* Кнопки сумм с горизонтальной прокруткой */}
            <div className="sum-buttons-scroll">
                <div className="sum-buttons">
                    {predefinedSums.map((sum) => (
                        <button
                            key={sum}
                            className={`sum-button ${selectedSum === sum && !isCustom ? 'selected' : ''}`}
                            onClick={() => handleSumClick(sum)}
                        >
                            {sum}
                        </button>
                    ))}
                    <div
                        className={`sum-button custom-sum-btn ${isCustom ? 'selected' : ''}`}
                        onClick={!isCustom ? handleCustomClick : undefined}
                    >
                        {isCustom ? (
                            <input
                                type="text"
                                inputMode="numeric"
                                placeholder="СУММА"
                                value={customSum}
                                onChange={handleCustomChange}
                                className="inline-custom-input"
                                autoFocus
                                onBlur={() => {
                                    if (!customSum) setIsCustom(false);
                                }}
                            />
                        ) : (
                            'ДРУГАЯ СУММА'
                        )}
                    </div>
                    <div className="scroll-spacer" style={{ width: '20px', flexShrink: 0 }}></div>
                </div>
            </div>

            {/* Комментарий */}
            <textarea
                placeholder="Комментарий"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="donate-comment"
                rows={2}
            />

            {/* Кнопка отправить */}
            <button className="donate-submit" onClick={handleSubmit}>
                ПОДДЕРЖАТЬ МЯТУ
            </button>

            {/* Boosty баннеры */}
            <div className="boosty-scroll">
                <div className="boosty-container">
                    {boostyBanners.map((banner, index) => (
                        <a
                            key={index}
                            href={banner.url}
                            target="_blank"
                            rel="noreferrer"
                            className="boosty-card"
                        >
                            <img src={banner.img} alt={`Boosty подписка`} />
                        </a>
                    ))}
                    <div className="scroll-spacer" style={{ width: '15px', flexShrink: 0 }}></div>
                </div>
            </div>
        </div>
    );
};

export default DonateScreen;
